import apiClient from "./apiClient";
import { BoardBacksService } from "./generated";
import { withApi } from "./openapiClient";

export const listPacks = () =>
  withApi(BoardBacksService.listPacksBoardbacksGet()).then((res) => res.data);
export const getPack = (id) =>
  withApi(
    BoardBacksService.getPackBoardbacksPackIdGet({
      packId: Number(id),
    })
  ).then((res) => res.data);
export const listPackCommittees = () => apiClient.get("/boardbacks/committees").then((r) => r.data);
export const createPack = (payload) => apiClient.post("/boardbacks", payload).then((r) => r.data);
export const updatePack = (id, payload) => apiClient.put(`/boardbacks/${id}`, payload).then((r) => r.data);
export const publishPack = (id) => apiClient.post(`/boardbacks/${id}/publish`).then((r) => r.data);

export const addSection = (packId, payload) =>
  apiClient.post(`/boardbacks/${packId}/sections`, payload).then((r) => r.data);
export const updateSection = (sectionId, payload) =>
  apiClient.put(`/boardbacks/sections/${sectionId}`, payload).then((r) => r.data);

export const listAgendaItems = (packId) =>
  apiClient.get(`/boardbacks/${packId}/agenda`).then((r) => r.data);
export const createAgendaItem = (packId, payload) =>
  apiClient.post(`/boardbacks/${packId}/agenda`, payload).then((r) => r.data);
export const updateAgendaItem = (packId, itemId, payload) =>
  apiClient.put(`/boardbacks/${packId}/agenda/${itemId}`, payload).then((r) => r.data);
export const deleteAgendaItem = (packId, itemId) =>
  apiClient.delete(`/boardbacks/${packId}/agenda/${itemId}`).then((r) => r.data);
export const deletePack = (packId) => apiClient.delete(`/boardbacks/${packId}`).then((r) => r.data);
export const reorderAgendaItems = (packId, items) =>
  apiClient.post(`/boardbacks/${packId}/agenda/reorder`, { items }).then((r) => r.data);
export const uploadAgendaAttachment = (packId, itemId, file, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(`/boardbacks/${packId}/agenda/${itemId}/attachments/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    ...config,
  }).then((r) => r.data);
};
export const deleteAgendaAttachment = (packId, attachmentId) =>
  apiClient.delete(`/boardbacks/${packId}/agenda/attachments/${attachmentId}`).then((r) => r.data);

export const addDocument = (sectionId, payload) =>
  apiClient.post(`/boardbacks/sections/${sectionId}/documents`, payload).then((r) => r.data);

export const listAnnotations = (docId) =>
  apiClient.get(`/boardbacks/documents/${docId}/annotations`).then((r) => r.data);
export const addAnnotation = (docId, payload) =>
  apiClient.post(`/boardbacks/documents/${docId}/annotations`, payload).then((r) => r.data);
export const listAgendaAttachmentAnnotations = (attachmentId) =>
  apiClient.get(`/boardbacks/agenda/attachments/${attachmentId}/annotations`).then((r) => r.data);
export const addAgendaAttachmentAnnotation = (attachmentId, payload) =>
  apiClient.post(`/boardbacks/agenda/attachments/${attachmentId}/annotations`, payload).then((r) => r.data);
export const shareAnnotation = (annotationId) =>
  apiClient.post(`/boardbacks/annotations/${annotationId}/share`, { visibility: "shared" }).then((r) => r.data);

export const uploadDocument = (sectionId, file, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(`/boardbacks/sections/${sectionId}/documents/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    ...config,
  });
};

export const listQuestions = (packId) => apiClient.get(`/boardbacks/${packId}/questions`).then((r) => r.data);
export const createQuestion = (packId, payload) =>
  apiClient.post(`/boardbacks/${packId}/questions`, payload).then((r) => r.data);
export const replyToQuestion = (questionId, payload) =>
  apiClient.post(`/boardbacks/questions/${questionId}/messages`, payload).then((r) => r.data);
export const resolveQuestion = (questionId) =>
  apiClient.post(`/boardbacks/questions/${questionId}/resolve`).then((r) => r.data);
export const unresolveQuestion = (questionId) =>
  apiClient.post(`/boardbacks/questions/${questionId}/unresolve`).then((r) => r.data);

export const createMotion = (packId, payload) =>
  apiClient.post(`/boardbacks/${packId}/motions`, payload).then((r) => r.data);
export const castBallot = (motionId, payload) =>
  apiClient.post(`/boardbacks/motions/${motionId}/ballots`, payload).then((r) => r.data);
export const closeMotion = (motionId) => apiClient.post(`/boardbacks/motions/${motionId}/close`).then((r) => r.data);

export const startExport = (packId) =>
  withApi(
    BoardBacksService.startExportBoardbacksPackIdExportPost({
      packId: Number(packId),
    })
  ).then((res) => res.data);

export const exportStatus = (exportId) =>
  withApi(
    BoardBacksService.getExportStatusBoardbacksExportsExportIdStatusGet({
      exportId: String(exportId),
    })
  ).then((res) => res.data);

export const downloadExport = (exportId) =>
  withApi(
    BoardBacksService.downloadExportBoardbacksExportsExportIdDownloadGet({
      exportId: String(exportId),
    })
  ).then((res) => res.data);

export const deleteDocument = (documentId) =>
  apiClient.delete(`/boardbacks/documents/${documentId}`).then((res) => res.data);
